import CompaniesTableView from './companiesTableView';

export default CompaniesTableView;
